{ Analytics, getScreenFromUrl } = require '@trello/atlassian-analytics'
BoardAddToTeam = require 'app/scripts/views/board-menu/board-add-to-team-view'
Controller = require 'app/scripts/controller'
ModelLoader = require 'app/scripts/db/model-loader'
PopOver = require 'app/scripts/views/lib/pop-over'
t = require('app/scripts/views/internal/teacup-with-helpers')('business_class_upsell')
{ trackUe } = require '@trello/analytics'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'

module.exports = class BusinessClassUpsellView extends View
  events:
    'click .js-business-class-upsell-upgrade': 'onUpgrade'
    'click .js-business-class-upsell-close': 'onClose'

  onUpgrade: (e) ->
    Util.stop(e)
    trackUe('Power-Up BC upgrade popover ad', 'clicks', 'upgrade button')
    Analytics.sendClickedButtonEvent({
      buttonName: 'upgradeToBCButton'
      source: 'pupLimitBCUpsellInlineDialog'
      containers:
        board:
          id: @model.id
    })

    if !@model.owned()
      window.location = '/business-class'
      return
    else if @model.hasOrganization()
      window.location = Controller.getBoardPowerUpsUpgradeUrl(@model)
      return

    ModelLoader.loadMyOrganizations()
    PopOver.toggle
      autoPosition: true
      elem: e.target
      getViewTitle: => t.l('upgrade-to-business-class')
      view: new BoardAddToTeam({ @model })

  onClose: (e) ->
    Util.stop(e)
    trackUe('Power-Up BC upgrade popover ad', 'close', 'Power-Up BC upgrade popover ad')
    PopOver.hide()

  render: ->
    Analytics.sendScreenEvent({
      name: 'pupLimitBCUpsellInlineDialog'
      containers:
        board:
          id: @model.id
        organization:
          id: @model.get('idOrganization')
      attributes:
        location: getScreenFromUrl()
    })
    @$el.html t.render =>
      t.div '.content', ->
        t.a '.icon-close.icon-lg.js-business-class-upsell-close', { href: '#' }
        t.h2 ->
          t.format 'this-board-has-reached-its-power-up-limit'
        t.p ->
          t.format 'teams-get-one-free-power-up-per-board-upgrade-to-business-class-for-additional-power-ups'
        t.p '.small', ->
          t.format 'additional-fees-may-be-required-for-paid-power-ups'
        t.a '.button-link.mod-full.js-business-class-upsell-upgrade', { href: '#' }, ->
          t.format 'upgrade'

    @
